import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Spinner from "@/components/atoms/Spinner/Spinner";

export default function RedirectLoadingScreen() {
  const location = useLocation();
  const target = new URLSearchParams(location.search).get("target");

  useEffect(() => {
    if (!target) return;
    const id = window.setTimeout(() => {
      window.location.href = target;
    }, 1000); // allow paint of spinner
    return () => window.clearTimeout(id);
  }, [target]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        zIndex: 9999,
      }}
    >
      <Spinner loading={true} />
    </div>
  );
}
